// Central content + CTA configuration for Capture By Parth Dixit

export const BRAND = {
  name: "Capture By Parth Dixit",
  shortName: "Parth Dixit",
  tagline: "Luxury Wedding Photography & Cinematography",
};

// The ONLY two actions on the entire site
const WA_MESSAGE = encodeURIComponent("Hi Parth, I'm interested in wedding photography");
export const LINKS = {
  whatsapp: `https://wa.me/918238546215?text=${WA_MESSAGE}`,
  instagram: "https://ig.me/m/capturebyparthdixit",
  instagramProfile: "https://instagram.com/capturebyparthdixit",
};

export const HERO = {
  overline: "Capture By Parth Dixit",
  // Gujarati headline split into masked reveal lines
  headingLines: [
    "શહેરની સૌથી શાનદાર",
    "Wedding Photography...",
    "હવે ₹1 લાખથી પણ",
    "ઓછી કિંમતમાં.",
  ],
  subheading:
    "Luxury Wedding Photography & Cinematography that looks premium, feels premium — but doesn't cost a fortune.",
  badges: ["Starting Under ₹1 Lakh", "Limited Wedding Dates Available"],
  video: "/portfolio/hero-reel.mp4",
  poster: "/portfolio/hero-poster.jpg",
};

export const WHY = {
  overline: "The Difference",
  heading: "Why Couples Choose",
  headingAccent: "Capture By Parth Dixit",
  points: [
    {
      no: "01",
      title: "Cinematic Storytelling",
      body: "Every frame colour-graded like a feature film. Your wedding, remembered the way it truly felt.",
    },
    {
      no: "02",
      title: "An Editorial Eye",
      body: "Magazine-grade composition, light and posing. Portraits that belong on a cover, not a camera roll.",
    },
    {
      no: "03",
      title: "Emotion, First",
      body: "We chase the stolen glances, the happy tears, the raw laughter — the moments money can't rehearse.",
    },
    {
      no: "04",
      title: "Premium, Priced Right",
      body: "Drone, candid, portraits & cinematography under one roof. World-class craft, without the world-class invoice.",
    },
  ],
};

export const MARQUEE_WORDS = [
  "Royal Portraits",
  "Golden Hour",
  "Drone Cinematics",
  "Editorial Frames",
  "Grand Entrances",
  "Emotional Moments",
  "Luxury Décor",
  "Timeless Films",
];

export const GALLERY = {
  overline: "The Portfolio",
  heading: "Weddings, remembered",
  headingAccent: "in gold.",
  images: [
    { src: "/portfolio/work-07.jpg", alt: "Bridal portrait in golden light" },
    { src: "/portfolio/work-01.jpg", alt: "Wedding ceremony under floral canopy" },
    { src: "/portfolio/work-03.jpg", alt: "Couple portrait by the sea at golden hour" },
    { src: "/portfolio/work-02.jpg", alt: "Night portrait of the couple with garlands" },
    { src: "/portfolio/work-09.jpg", alt: "Bride in soft golden light" },
    { src: "/portfolio/work-06.jpg", alt: "Bride in red at heritage arches" },
    { src: "/portfolio/work-04.jpg", alt: "Playful couple moment on the beach" },
    { src: "/portfolio/work-08.jpg", alt: "Editorial bridal portrait" },
    { src: "/portfolio/work-05.jpg", alt: "Couple running on the shore" },
  ],
};

export const TESTIMONIALS = {
  overline: "Social Proof",
  heading: "The reaction is always the same.",
  items: [
    {
      quote: "Everyone thought we hired a celebrity wedding photographer.",
      name: "Aarav & Diya",
      place: "Ahmedabad",
    },
    {
      quote: "The quality was beyond anything we imagined.",
      name: "Rishi & Meera",
      place: "Surat",
    },
    {
      quote: "Our best wedding decision.",
      name: "Karan & Isha",
      place: "Vadodara",
    },
  ],
};

export const FINAL = {
  overline: "Only Two Steps Left",
  headingGuj: "તમારી Wedding Date કોઈ બીજો બુક કરે એ પહેલાં...",
  headingEn: "Let's create memories you'll relive forever.",
  bg: "/portfolio/work-02.jpg",
};
